import {contentManager} from '../../../api/contentManager';

import CompetencesContentPage from '../../../api/competencesPageEntity';
import { notifyBreadcrumChangeAction } from '../../../common/components/breadcrumb/actions/notifyBreadcrumChange';
import { actionTypes } from '../../../common/constants/actionTypes';

import { httpCallStartAction } from '../../../middlewares/http/actions';

export const fetchCompetencesPageAction = () => (dispatch: any) => {
    dispatch(httpCallStartAction());

    contentManager.fetchCompetencesContentPageAsync()
    .then((competenceItem) => {
      dispatch(fetchCompetencesContentPageCompleted(competenceItem));
      dispatch(notifyBreadcrumChangeAction(actionTypes.BREADCRUMB_CHANGED_ON_COMPETENCES_PAGE, "Pätevyydet"));
    });
};

const fetchCompetencesContentPageCompleted = (competencesPage: CompetencesContentPage) => ({
    meta: {
        httpEnd: true,
      },
    payload: competencesPage,
    type: actionTypes.FETCH_COMPETENCES_ITEMS_COMPLETED
});


// WEBPACK FOOTER //
// ./src/components/competencesPage/actions/fetchCompetencesPage.ts